/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurfaceStreamZoneOverlaySponsor
 */
export interface SurfaceStreamZoneOverlaySponsor {
    /**
     * 
     * @type {string}
     * @memberof SurfaceStreamZoneOverlaySponsor
     */
    iconUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceStreamZoneOverlaySponsor
     */
    name: string;
}

/**
 * Check if a given object implements the SurfaceStreamZoneOverlaySponsor interface.
 */
export function instanceOfSurfaceStreamZoneOverlaySponsor(value: object): value is SurfaceStreamZoneOverlaySponsor {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function SurfaceStreamZoneOverlaySponsorFromJSON(json: any): SurfaceStreamZoneOverlaySponsor {
    return SurfaceStreamZoneOverlaySponsorFromJSONTyped(json, false);
}

export function SurfaceStreamZoneOverlaySponsorFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceStreamZoneOverlaySponsor {
    if (json == null) {
        return json;
    }
    return {
        
        'iconUrl': json['iconUrl'] == null ? undefined : json['iconUrl'],
        'name': json['name'],
    };
}

export function SurfaceStreamZoneOverlaySponsorToJSON(json: any): SurfaceStreamZoneOverlaySponsor {
    return SurfaceStreamZoneOverlaySponsorToJSONTyped(json, false);
}

export function SurfaceStreamZoneOverlaySponsorToJSONTyped(value?: SurfaceStreamZoneOverlaySponsor | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'iconUrl': value['iconUrl'],
        'name': value['name'],
    };
}

